import _ from 'lodash'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { resetErrors } from '../../../reducers/programPresentationReducer'
import { getSignUpPageProgram } from '../../../actions/programActions'
import LandingHeader from '../../common/LandingHeader'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import LockError from '../../common/LockError'

import styles from './ProgramLandingPage.module.scss'

const ProgramLandingPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const user = useSelector(state => state.user.current_user)
  const { course, isLoading, errors } = useSelector(state => state.programPresentation)

  useEffect(() => {
    dispatch(getSignUpPageProgram(params.courseId))
      .unwrap()
      .then(response => {
        if (response.course.community.id.toString() !== params.communityId) {
          navigate(`/landing/${response.course.community.id}/class/${params.courseId}`)
        }
      })

    return () => {
      dispatch(resetErrors())
    }
  }, [dispatch, navigate, params.communityId, params.courseId])

  return (
    <div className='h-100'>
      <LandingHeader />

      <div className={classnames(styles.programLandingContent, 'd-flex flex-column')}>
        {!_.isEmpty(errors) ? (
          <LockError
            titleText={t('programs.common.programNotFound')}
            linkAttributes={{
              linkMessage: t('programs.common.browseOtherPrograms'),
              navigateTo: user && user.communities[0]?.id ? `/landing/${user.communities[0].id}` : '/community-map',
            }}
          >
            <p>
              {t('programs.landing.notFoundDescription')}
            </p>
          </LockError>
        ) : isLoading || _.isEmpty(course)
          ? <Loader message={t('programs.common.loadingProgram')} />
          : <Outlet />
        }
      </div>
    </div>
  )
}

export default ProgramLandingPage
